import "../index.css";
import { useState } from "react";
import Button from "../components/button/button";
import PolicyContainer from "../components/policy/policyContainer";
import axios from "axios";
import { baseURL } from "../baseURL";

const PopUpScorecardFormDownloadScorecard = ({
  onClose,
  onSuccess,
  onError,
}) => {
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmitDownloadForm = async (e) => {
    e.preventDefault();

    const dataToSend = {
      ...formData,
      scorecardForm: true,
    };

    try {
      const response = await axios.post(
        `${baseURL}/api/submit-download-form`,
        dataToSend,
        {
          withCredentials: "true", // This matches the backend CORS policy
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200) {
        onSuccess("scorecard-download");
        onClose();
      }
    } catch (error) {
      console.error("Error submitting form:", error.response || error.message);
      onError(error);
    }
  };

  return (
    <>
      <div className="pop-up-form">
        <div className="form-header">
          <h4>Download the Scorecard</h4>
          <div className="close-btn-x" onClick={onClose}>
            <i class="fa-solid fa-xmark"></i>
          </div>
        </div>
        <form id="scorecardForm" onSubmit={handleSubmitDownloadForm}>
          <p>
            Providing your contact information enables us to share best
            practices, communicate updates, and network with our global wildfire
            prevention community.
          </p>
          <div className="form-group">
            <label for="firstName">*First Name </label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              onChange={handleChange}
              value={formData.firstName}
              required
            />
          </div>
          <div className="form-group">
            <label for="lastName">*Last Name</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              onChange={handleChange}
              value={formData.lastName}
              required
            />
          </div>
          <div className="form-group">
            <label for="email">*Email</label>
            <input
              type="email"
              id="email"
              name="email"
              onChange={handleChange}
              value={formData.email}
              required
            />
          </div>
          <div className="form-group">
            <label for="organization">Organization</label>
            <input
              type="text"
              id="organization"
              name="organization"
              onChange={handleChange}
              value={formData.organization}
            />
          </div>
          <div className="form-group">
            <label for="role">Role</label>
            <input
              type="text"
              id="role"
              name="role"
              onChange={handleChange}
              value={formData.role}
            />
          </div>
          <div className="form-group">
            <label for="zipCode">*Zip/Postal Code</label>
            <input
              type="text"
              id="zipCode"
              name="zipCode"
              onChange={handleChange}
              value={formData.zipCode}
              required
              minLength={4}
            />
          </div>
          <div className="form-group">
            <label for="message">Message</label>
            <textarea
              id="message"
              name="message"
              cols="50"
              onChange={handleChange}
              value={formData.message}
            ></textarea>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              id="subscribe"
              name="subscribe"
              onChange={handleChange}
              value={formData.subscribe}
            />
            <label for="subscribe">Subscribe</label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              id="pilot"
              name="pilot"
              onChange={handleChange}
              value={formData.pilot}
            />
            <label for="pilot">I'm interested in piloting with CWPC</label>
          </div>
          <Button
            text="Download Scorecard"
            color="var(--green)"
            className="pop-up-btn"
          ></Button>
        </form>
        <div className="policy">
          <PolicyContainer text="Download" />
        </div>
        <div className="form-footer">
          <div className="form-close-btn" onClick={onClose}>
            Close
          </div>
        </div>
      </div>
    </>
  );
};

export default PopUpScorecardFormDownloadScorecard;
